import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AbsenceApplication } from '@/components/AbsenceApplication/types';
import { Calendar } from '@/components/Icons/Calendar';
import { countDaysInclusive, formatDateRange } from '@/utils/date';

interface Props {
  application: AbsenceApplication;
  onClick: (id: number) => void;
}

export const AbsenceActiveCard: React.FC<Props> = ({
  application,
  onClick,
}) => {
  const { t } = useTranslation();
  const { from, to } = application.absencePeriod;
  const periodText = formatDateRange(from, to);
  const daysCount = countDaysInclusive(from, to);

  return (
    <button
      type="button"
      onClick={() => onClick(application.id)}
      className="flex min-w-0 cursor-pointer items-center gap-3 rounded-xl bg-popover px-4 py-3 text-left shadow-card"
    >
      <span className="flex items-center justify-center rounded-full bg-info-surface p-2 text-primary">
        <Calendar className="size-4" />
      </span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="text-subhead-14 truncate text-foreground">{periodText}</p>
        <p className="text-caption-12 truncate text-muted-foreground">
          {t('absenceHistory.days', { count: daysCount })}
        </p>
      </div>
    </button>
  );
};
